import React  from "react";
import ChatConversationList from "./components/ChatConversationList";
import SummaryHeader from "components/header/SummaryHeader";

const HyvidChat = () => {
	
	return (
	    <div>
			<SummaryHeader
				title={"Hyvid Chat"}
				iconName="MessagesSquare"
				description={"Communicate with your colleagues and team members in real-time using Hyvid Chat."}
				color={"purple"}
			/>
			<div className="mt-5 grid h-full grid-cols-4 gap-4">      		
				<ChatConversationList />
			</div>
	    </div>
    );
};

export default HyvidChat;